import i18n from '.';

// Joi error codes we word ourselves. Every error shows under its own field, so the messages leave
// the field's name out, which also spares Spanish from agreeing with it.
const KEYS = {
  'any.required': 'required',
  'string.empty': 'required',
  'string.email': 'email',
  'string.min': 'stringMin',
  'string.max': 'stringMax',
  'string.pattern.base': 'pattern',
  'number.base': 'number',
  'number.min': 'numberMin',
  'number.max': 'numberMax',
  'date.base': 'date',
};

// Joi renders these codes as a marker plus the code. A schema's own `.messages()` still wins over
// them, so a message without the marker is the schema's and is kept as it is.
const MARK = '§joi:';

export const validationOptions = {
  messages: Object.fromEntries(Object.keys(KEYS).map((code) => [code, MARK + code])),
};

/** The message for one Joi error detail, in the app's language. */
export const validationMessage = ({ message, type, context = {} }) => {
  if (!message.startsWith(MARK)) return message;

  return i18n.t(`validation.${KEYS[type]}`, { count: context.limit, limit: context.limit });
};
